import { Controller } from "stimulus"

// #1996: de rechterkolom van Schema toevoegen: trainingen per week × weken is
// het totaal aantal sessies, zoals Schemaplanning. Gaat dat niet op in volle
// rondes, dan staat hier wat de onvolledige laatste ronde is.
export default class extends Controller {
  static targets = ["weken", "perWeek", "uitkomst", "keuze"]
  static values = { trainingen: Number, max: Number, sessies: String, ronde: String }

  reken() {
    const weken = Number.parseInt(this.wekenTarget.value, 10)
    const perWeek = Number.parseInt(this.perWeekTarget.value, 10)
    if (!(weken >= 1 && weken <= this.maxValue && perWeek >= 1 && this.trainingenValue >= 1)) {
      this.uitkomstTarget.textContent = ""
      return
    }

    const totaal = weken * perWeek
    const rest = totaal % this.trainingenValue
    const ronde = rest > 0
      ? ` ${this.rondeValue.replace("%{rest}", rest).replace("%{trainingen}", this.trainingenValue)}`
      : ""
    this.uitkomstTarget.textContent = this.sessiesValue.replace("%{aantal}", totaal) + ronde
  }

  annuleer() {
    this.keuzeTarget.open = false
  }
}
